/**
 * @ngdoc directive
 * @module components.pagination
 * @name components.pagination:paginationLoadMore
 * @restrict E
 * @requires pagination
 * @description
 * Appends the next page of paginated results to the current list when clicked. Any markup can be passed into the component. This button will disappear when there are no more items to load.
 * @example
    <example module="dataExample">
        <file name="index.html">
            <div ng-controller="exampleController">
                <pagination data="exampleData">
                    <ul>
                        <li ng-repeat="item in $ctrl.items">{{item}}</li>
                    </ul>
                    <pagination-load-more>Click me to load more!!!</pagination-load-more>
                </pagination>
            </div>
        </file>
        <file name="script.js">
            (function() {
                angular.module('dataExample', ['components.pagination'])
                    .controller('exampleController', exampleController);

                exampleController.$inject = ['$scope'];
                function exampleController($scope) {
                    var data = [];
                    for (var i=0; i<25; i++) {
                        data.push('example ' + i);
                    }
                    $scope.exampleData = data;
                }
            })();
        </file>
    </example>
 */
(function () {
    angular.module('components.pagination')
        .component('paginationLoadMore', {
            require: {
                pagination: '^pagination'
            },
            transclude: true,
            controller: paginationLoadMoreController,
            template: '<div ng-click="$ctrl.loadMore()" ng-hide="$ctrl.pagination.finished"></div>'
        });

    paginationLoadMoreController.$inject = ['$element', '$transclude'];
    function paginationLoadMoreController($element, $transclude) {
        var ctrl = this;
        ctrl.$onInit = function () {
            $transclude(function (clone) {
                if (clone.length) {
                    $element.find('div').html(clone);
                }
            })
        }

        ctrl.loadMore = function () {
            ctrl.pagination.nextPage();
        }
    }
})();